// removed by extract-text-webpack-plugin
module.exports = {"label":"label___12Yoo","schemas":"schemas___3kiOC"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/EditorGUI/CheckBox/styles.scss
// module id = 454
// module chunks = 0